<div id="userMap" class="map-canvas"></div>

<aside class="map-operation-hints" aria-label="Map controls">
  <div class="map-control-surface map-hint-panel" [class.map-hint-panel-expanded]="mapHintsVisible">
    <button type="button" class="map-control-button map-hint-toggle"
      [attr.aria-label]="mapHintsVisible ? 'Hide map controls' : 'Show map controls'"
      [attr.aria-expanded]="mapHintsVisible" aria-controls="map-controls-help"
      (click)="mapHintsVisible = !mapHintsVisible">
      <br-icon aria-hidden="true">info_outline</br-icon>
    </button>
    <div *ngIf="mapHintsVisible" id="map-controls-help" class="map-hint-content br-small br-text-secondary">
      <dl class="map-hint-instructions map-hint-desktop">
        <div class="map-hint-row">
          <dt class="map-hint-input">Click</dt><dd>Select &amp; view</dd>
        </div>
        <div class="map-hint-row">
          <dt class="map-hint-input"><kbd>Shift</kbd> + click</dt><dd>Add / remove</dd>
        </div>
        <div class="map-hint-row">
          <dt class="map-hint-input"><kbd>Shift</kbd> + drag</dt><dd>Box select</dd>
        </div>
        <div class="map-hint-row">
          <dt class="map-hint-input"><kbd>{{ interactionController.clearShortcutLabel }}</kbd></dt><dd>Clear selection</dd>
        </div>
      </dl>
      <dl class="map-hint-instructions map-hint-touch">
        <div class="map-hint-row">
          <dt class="map-hint-input">Hold, then tap</dt><dd>Add / remove</dd>
        </div>
        <div class="map-hint-row">
          <dt class="map-hint-input">Tap empty map</dt><dd>Clear selection</dd>
        </div>
      </dl>
    </div>
  </div>
</aside>
